module.exports = __webpack_public_path__ + "img/icon3.b1a63685.png";